<template>
  <div class="main print-no-padding download">
    <h2 class="is-print-hide title-area">
      <span class="main-title">下载中心</span>
      <span class="sub-title">报表下载有效期为7天，请及时下载</span>
    </h2>
    <el-card>
      <search-bar :search-params="searchParams" @change="change" @search="search" />
      <download-table :data="list" @cancel-export="cancelExport" @download="downloadFile" />
      <pagination
        :page-no="pageNo"
        :page-size="pageSize"
        :page-sizes="pageSizes"
        :total="total"
        @handle-pageNo="handlePageNoChange"
        @handle-pageSize="handlePageSizeChange"
      />
    </el-card>
    <!-- <direction></direction> -->
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { download, downloadByLink } from '@/util';
import Fetch from '@/api';
import searchBar from './components/searchBar';
import downloadTable from './components/downloadTable';
import pagination from './components/pagination';
// import direction from '@/components/global/direction/index';

let timer = null;

const duration = 30 * 1000;

export default {
  name: 'download',
  components: {
    searchBar,
    downloadTable,
    pagination
    // direction
  },
  data() {
    return {
      list: [],
      searchParams: {
        date: [],
        type: ''
      },
      total: 0,
      pageNo: 1,
      pageSize: 12,
      pageSizes: [12, 24, 36, 48]
    };
  },
  methods: {
    fetchList(params) {
      const { date, type, ...rest } = params;
      const [startTime, endTime] = date || [];
      return Fetch.export_async_task_query({ startTime, endTime, typeList: type ? [type] : [], ...rest }).then(
        ({ data, totalCount, pageNo, pageSize }) => {
          this.list = data;
          this.pageNo = pageNo;
          this.pageSize = pageSize;
          this.total = totalCount;
        }
      );
    },
    init() {
      return this.fetchList({ pageNo: 1, pageSize: 12 });
    },
    search() {
      const { searchParams, pageSize } = this;
      return this.fetchList({ ...searchParams, pageNo: 1, pageSize });
    },
    handlePageNoChange(val) {
      const { searchParams, pageSize } = this;
      timer && clearTimeout(timer);
      return this.fetchList({ ...searchParams, pageNo: val, pageSize }).then(_ => {
        timer = setTimeout(_ => this.refreshList(), duration);
      });
    },
    handlePageSizeChange(val) {
      const { searchParams, pageNo } = this;
      timer && clearTimeout(timer);
      return this.fetchList({ ...searchParams, pageNo, pageSize: val }).then(_ => {
        timer = setTimeout(_ => this.refreshList(), duration);
      });
    },
    cancelExport(id) {
      Fetch.export_async_cancel(id).then(
        _ => {
          const { searchParams, pageNo, pageSize } = this;
          this.fetchList({ ...searchParams, pageNo, pageSize });
        },
        _ => {
          this.init();
        }
      );
    },
    change(field, value) {
      this.searchParams[field] = value;
    },
    downloadFile(id, type, ext) {
      return Fetch.export_async_get_file_url(id).then(
        ({ url }) => {
          const _url = url.replace('http:', '');
          download(
            _url,
            `${type}${dayjs().format('YYYYMMDD')}.${ext}`,
            event => this.progress(event, id),
            event => this.load(event, id)
          );
        },
        _ => {
          this.init();
        }
      );
    },
    progress(event, id) {
      this.list = this.list.map(item => {
        if (item.id === id) {
          item.status = 'FETCH';
          item.progress = '已下载' + Math.round((event.loaded / event.total) * 100) + '%';
        }
        return item;
      });
    },
    load(event, id) {
      this.list = this.list.map(item => {
        if (item.id === id) {
          item.status = 'FINISH';
        }
        return item;
      });
    },
    refreshList() {
      const isRefresh = this.list.some(item => item.status == 'INIT' || item.status == 'RUNNING');
      if (isRefresh) {
        this.fetchList({ ...this.searchParams, pageNo: this.pageNo, pageSize: this.pageSize }).then(_ => {
          timer && clearTimeout(timer);
          timer = setTimeout(_ => this.refreshList(), duration);
        });
      } else {
        timer && clearTimeout(timer);
      }
    }
  },
  created() {
    this.init().then(_ => {
      timer = setTimeout(_ => this.refreshList(), duration);
    });
  },
  beforeDestroy() {
    timer && clearTimeout(timer);
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.commit('download/RESET_DOWNLOAD_COUNT');
    });
  }
};
</script>

<style lang="scss" scoped>
.download {
  .sub-title {
    margin-left: 8px;
    font-size: 12px;
    color: #bdbdbd;
  }
}
</style>
